import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

// Lib
import handleCopyValue from '@/methods/handleCopyValue'
import getUrlWithNewSearch from '@/methods/url/getUrlWithNewSearch'
import { handleGtmShare } from '@/methods/handleGtmEvent'
import { LIVE_SOURCE_QUERY, LIVE_TRACK_EVENT, LIVE_TRAFFIC_SOURCE, trackCurrentLiveRoomEvent } from '@/methods/liveTracking'
import { ROUTE_PATH } from '@/constants/routePath'

// Components
import ProductContent from './components/ProductContent'
import Popup from '@/components/common/Popup'
import Icon from '@/assets/icons'

// Constants
import { envConfigs } from '@/constants/config'
import { GtmShareContentType, GtmShareMethod } from '@/constants/gtmEvent'

// Styles
import styles from './style.module.scss'
import { useMutation } from 'react-query'
import { increaseShares } from '@/api/increaseShares'
import { useParams } from 'next/navigation'
import { VALID_BRAND_NAME } from '@/constants/brand'

const cx = classnames.bind(styles)
interface SharePopupProps {
  isOpen: boolean
  type?: string
  productInfo?: any
  liveInfo?: any
  mainInfo?: any
  onCancel: () => void
  gtmShareContentType: GtmShareContentType
}

const SharePopup = (props: SharePopupProps) => {
  const { isOpen, productInfo, onCancel, type, gtmShareContentType } = props

  const { t } = useTranslation()
  const { mutate: increaseSharesMutation, isLoading: isIncreasingShares } = useMutation(increaseShares)

  const router = useRouter()
  const id = router?.query?.id

  const params = useParams()
  const isPxECRoom = params.brandName === VALID_BRAND_NAME.PXEC
  const roomId = params.roomId

  // TODO: 三種分享對象的樣式要長得不一樣 要再開發
  const defineContentType = (type: string) => {
    switch (type) {
      case 'product':
        return productInfo && <ProductContent productInfo={productInfo} />
      // case 'liveRoom':
      //   return <LiveRoomContent {...props} />
      //   break;
      // case 'main':
      //   return <MainContent {...props} />
      //   break;
      default:
        return
    }
  }

  const fullUrl = getUrlWithNewSearch({
    url: `${envConfigs.domainUrl}${router.asPath}`,
    isLowerCase: true,
    // 從直播間分享出去的連結帶 src=share，點進來時記成「分享」流量來源
    searchParams: {
      openExternalBrowser: 1,
      ...(router.pathname.startsWith(`${ROUTE_PATH.LIVE}/`) && { [LIVE_SOURCE_QUERY]: LIVE_TRAFFIC_SOURCE.SHARE }),
    },
  })

  const handleIncreaseShares = () => {
    trackCurrentLiveRoomEvent(LIVE_TRACK_EVENT.SHARE) // 只在直播間記
    if (!isPxECRoom || !roomId) return

    increaseSharesMutation({
      roomId: String(roomId),
    })
  }

  return (
    <Popup
      onCancel={() => onCancel()}
      canClose
      isOpen={isOpen}
      hasCancel={false}
      hasConfirm={false}
      popupClassname={cx('popup')}
      wrapperClassname={cx('popup-wrapper')}
    >
      <div className={cx('share-popup')}>
        {type && defineContentType(type)}
        <div className={cx('share-popup-section')}>
          <div className={cx('share-popup-section-description')}>
            <p>{t('Common_Share_Friend')}</p>
          </div>
          <div className={cx('share-popup-section-icon-wrapper')}>
            <div
              className={cx('share-popup-section-icon')}
              onClick={() => {
                if (isIncreasingShares) return
                handleCopyValue({ t, value: fullUrl })
                handleGtmShare({ contentId: id as string, contentType: gtmShareContentType, method: GtmShareMethod.LINK })
                handleIncreaseShares()
              }}
            >
              <Icon.ShareLink />
            </div>
            {/* TODO: 研究如何把圖片存下來並導到instagram發文 */}
            {/* <div
              className={cx('share-popup-section-icon')}
              onClick={() => {
                //https://www.instagram.com/?url=http://dev.tutorabcshop.com:8001/product/485
                const instagramUrl = `instagram-stories://share?AssetPath=${encodeURIComponent(image)}`
                console.log(instagramUrl)
                window.open(instagramUrl)
              }}
            >
              <Icon.ShareInstagram />
            </div> */}
            <div
              className={cx('share-popup-section-icon')}
              onClick={() => {
                if (isIncreasingShares) return
                //http://line.naver.jp/R/msg/text/?網址
                const lineUrl = 'http://line.naver.jp/R/msg/text/?'
                window.open(lineUrl + fullUrl)
                handleGtmShare({ contentId: id as string, contentType: gtmShareContentType, method: GtmShareMethod.LINE })
                handleIncreaseShares()
              }}
            >
              <Icon.ShareLine />
            </div>
            <div
              className={cx('share-popup-section-icon')}
              onClick={() => {
                if (isIncreasingShares) return
                //'https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fdev.tutorabcshop.com%3A8001%2Fproduct%2F485
                const facbookUrl = 'https://www.facebook.com/sharer/sharer.php?u='
                window.open(facbookUrl + fullUrl, '_blank')
                handleGtmShare({ contentId: id as string, contentType: gtmShareContentType, method: GtmShareMethod.FACEBOOK })
                handleIncreaseShares()
              }}
            >
              <Icon.ShareFacebook />
            </div>
          </div>
        </div>
      </div>
    </Popup>
  )
}
export default SharePopup
